import removeBackground from '@imgly/background-removal';

import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';

const ImageMattingContext = createContext({
  status: 'idle',
  processMessage: '',
  hasProcessedImage: false,
  processImage: (path) => {},
  imageUrl: '',
  originalImageUrl: '',
  resetState: () => {},
  inferenceTime: 0,
  imageType : '',
  fileType: (type) => {},
});

const STATUS_MESSAGES = {
  idle: '',
  init: '...',
  fetching: '이미지를 분석하고 있습니다.',
  processing: '이미지 배경을 제거하는 중입니다.',
  done: '',
  error: 'Error: 배경을 제거하는 중 오류가 발생하였습니다'
};
const PROCESSING_STATUS = ['init', 'fetching', 'processing'];

const ImageMattingContextProvider = ({ children }) => {
  const [status, setStatus] = useState('idle');
  const processMessage = useMemo(() => STATUS_MESSAGES[status], [status]);
  const [hasProcessedImage, setHasProcessedImage] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [originalImageUrl, setOriginalImageUrl] = useState();
  const [inferenceTime, setInferenceTime] = useState(0);
  const [imageType, setImageType] = useState('')

  function resetState() {
    setStatus('idle');
    setHasProcessedImage(false);
    setImageUrl('');
  }

  const fileType = useCallback(async (type) => {
    if(type){
      if(type == 'image/jpeg') setImageType('jpg')
      else setImageType('png')
    }else{
      setImageType('png')
    }
  }, [])

  const processImage = useCallback(async (path) => {
    setOriginalImageUrl(path);

    const response = await fetch(path);
    const blob = await response.blob();
    const startTime = Date.now();

    setStatus('init');
    let imageBlob;
    try {
      imageBlob = await removeBackground(blob, {
        progress: (key, current, total) => {
          if (key.startsWith('fetch:')) {
            setStatus('fetching');
          } else if (key.startsWith('compute:inference')) {
            setStatus('processing');
          }
        }
      });
    } catch (error) {
      setStatus('error');
      console.error(error);
      alert('오류가 발생하였습니다. 파일형식을 확인해주세요.')
      return;
    }
    const timeDiffInSeconds = (Date.now() - startTime) / 1000;
    setInferenceTime(timeDiffInSeconds);
    setHasProcessedImage(true);
    setImageUrl(URL.createObjectURL(imageBlob));
    setStatus('idle');
  }, []);

  return (
    <ImageMattingContext.Provider
      value={{
        status,
        isProcessing: PROCESSING_STATUS.includes(status),
        processMessage,
        hasProcessedImage,
        imageUrl,
        originalImageUrl,
        processImage,
        resetState,
        inferenceTime,
        imageType,
        fileType,
      }}
    >
      {children}
    </ImageMattingContext.Provider>
  );
};

export const useImageRemover = () => {
  const context = useContext(ImageMattingContext);
  if (context === undefined) {
    throw new Error();
  }
  return context;
};

export { ImageMattingContext, ImageMattingContextProvider };
